/** Libellés de présentation uniquement : ne modifie jamais les résultats exportés. */
const labels = {
  termination: {
    completed: 'Recherche terminée',
    node_budget_exhausted: 'Limite de configurations explorées atteinte',
    candidate_budget_exhausted: 'Limite de placements évalués atteinte',
    timeout: 'Temps maximal de calcul atteint',
    deadline_exceeded: 'Échéance de calcul atteinte',
    cancelled: 'Calcul annulé', failed: 'Échec du calcul',
    running: 'Calcul en cours', queued: 'En attente de calcul', draft: 'Brouillon',
  },
  algorithm: {
    ffd: 'Premier emplacement compatible, par ordre décroissant',
    best_fit: 'Meilleur ajustement', hybrid: 'Méthode hybride',
    beam_search: 'Comparaison progressive de plusieurs solutions',
  },
  strategy: {
    volume_desc: 'Colis les plus volumineux en premier',
    weight_desc: 'Colis les plus lourds en premier',
    unloading_order: 'Ordre de déchargement', composite: 'Combinaison de critères',
    auto: 'Automatique',
  },
  phase: {
    preparation: 'Préparation des données', search: 'Recherche des placements',
    repair: 'Tentative de placement des colis restants', validation: 'Validation finale',
  },
  objective: {
    utilization: 'Utilisation de l’espace', stability: 'Stabilité des appuis',
    weightDistribution: 'Répartition des masses', accessibility: 'Accessibilité des colis',
    centerOfGravity: 'Position du centre de gravité', stackability: 'Empilabilité',
    dynamicStability: 'Indicateurs de stabilité du modèle',
    rollover: 'Indicateur de basculement', yaw: 'Indicateur de lacet', roll: 'Indicateur de roulis',
    rotationPreference: 'Respect des orientations préférées', loadingSequence: 'Ordre de chargement',
    baseFootprint: 'Surface d’appui au sol', lateralStackStability: 'Stabilité latérale des piles',
    rowConsistency: 'Régularité des rangées', layerContactContinuity: 'Continuité des contacts entre couches',
    transverseTiling: 'Occupation de la largeur', stackCompactness: 'Compacité des piles',
    verticalLayerContinuity: 'Continuité verticale des couches', groupCohesion: 'Regroupement des colis associés',
    groupFootprintConsistency: 'Régularité de l’emprise des groupes',
    internalVoidControl: 'Réduction des espaces vides internes',
    lateralVoidControl: 'Réduction des espaces vides latéraux',
    longitudinalVoidControl: 'Réduction des espaces vides longitudinaux',
    crossSkuInternalVoidControl: 'Réduction des vides entre références',
    floorFrontContinuity: 'Continuité du chargement à l’avant du plancher',
    sameSkuGridCompactness: 'Compacité des colis de même référence',
    floorLengthEfficiency: 'Efficacité de la longueur occupée au sol',
    progressiveLateralBalance: 'Équilibrage latéral progressif',
    constraintPenalty: 'Pénalité liée aux contraintes', temperatureCompatibility: 'Compatibilité des températures',
  },
} as const

export type DiagnosticKind = keyof typeof labels
const normalize = (value: string) => value.toLowerCase().replace(/[_\s-]/g, '')
const lookup = Object.fromEntries(Object.entries(labels).map(([kind, entries]) => [kind,
  Object.fromEntries(Object.entries(entries).map(([code, label]) => [normalize(code), label]))
])) as Record<DiagnosticKind, Record<string, string>>

export function diagnosticLabel(kind: DiagnosticKind, code: unknown): string {
  if (typeof code !== 'string' || !code.trim()) return 'Non renseigné'
  const key = normalize(code)
  if (Object.prototype.hasOwnProperty.call(lookup[kind], key)) return lookup[kind][key]
  return {
    termination: 'Autre motif d’arrêt', algorithm: 'Autre algorithme', strategy: 'Autre stratégie',
    phase: 'Autre phase de calcul', objective: 'Autre critère de qualité',
  }[kind]
}
